import React from 'react';
import { ExecutionEditor } from './ExecutionEditor';
import { PlanningEditor } from './PlanningEditor';
import { SafetyEditor } from './SafetyEditor';
import { QaQcEditor } from './QaQcEditor';
import { StoresEditor } from './StoresEditor';
import { ProcurementEditor } from './ProcurementEditor';

export function SectionEditor({ dept, deptLabel, section, meta, onSaved, projectId, date, readOnly = false }) {
  const initialData = section?.data || {};
  const common = { data: initialData, dept, deptLabel, onSaved, projectId, date, readOnly };
  let editor;
  if (dept === 'execution') {
    editor = <ExecutionEditor data={initialData} meta={meta} onSaved={onSaved} projectId={projectId} date={date} deptLabel={deptLabel} readOnly={readOnly} />;
  } else if (dept === 'planning') editor = <PlanningEditor {...common} />;
  else if (dept === 'safety') editor = <SafetyEditor {...common} />;
  else if (dept === 'qa_qc') editor = <QaQcEditor {...common} />;
  else if (dept === 'stores') editor = <StoresEditor {...common} />;
  else if (dept === 'procurement') editor = <ProcurementEditor {...common} />;
  else editor = <PlanningEditor {...common} />;

  // G.1 — read-only view for a section the current user can't edit (finalised
  // DPR, or another department's section): <fieldset disabled> greys out every
  // native input/select/textarea/button without touching each editor's markup.
  // display:contents keeps the fieldset invisible to layout.
  return readOnly
    ? <fieldset disabled style={{ display: 'contents' }} data-testid={`dpr-section-${dept}-readonly`}>{editor}</fieldset>
    : editor;
}
